import ShadowScrollbars from "../../../../ui/custom_scrollbars/ShadowScrollbars";
import {Col, Container, Row} from "react-bootstrap";
import ResultCard from "../cards/ResultCard";
import {gql, useQuery} from "@apollo/client";
import liverpoolLogo from "../../../../../assets/img/demo/liverpool-logo.png";
import dustinWilliamsonAvatar from "../../../../../assets/img/demo/dustin-williamson-avatar.png";
import eduardoMilesAvatar from "../../../../../assets/img/demo/eduardo-miles-avatar.png";
import React, {Fragment, useEffect, useRef, useState} from "react";
import Tools from "../../../../../Tools";
import NoError from "../../../../ui/feedback/NoError";
import NoResultFound from "../../../../ui/feedback/NoResultFound";
import Pagination from "../../../../ui/pagination/Pagination";

const MatchesResults = props => {
    const query = gql`
        query getMatches(
            $q: String,
            $regions: [String!],
            $countries: [String!],
            $competitions: [String!],
            $teams: [String!],
            $stadiums: [String!],
            $skip: Int,
            $take: Int
        ){
            matches: getMatches(
                q: $q,
                regions: $regions,
                countries: $countries,
                competitions: $competitions,
                teams: $teams,
                stadiums: $stadiums,
                skip: $skip,
                take: $take
            ){
                total
                filteredFrom
                results{
                    ...matchFields
                }
            }
        }
        fragment matchFields on MatchModel {
            id
            homeTeam{
                team{
                    name
                    logo
                }
            }
            awayTeam{
                team{
                    name
                    logo
                }
            }
            goals{
                team{
                    name
                }
                soccer{
                    name
                    careerStats{
                        redCards
                        yellowCards
                    }
                }

                assistantFirst{
                    name
                    careerStats{
                        redCards
                        yellowCards
                    }
                }
                time
            }
        }
    `;

    const formatCard = player => player.careerStats.redCards ? 'red' : player.careerStats.yellowCards ? 'yellow' : undefined;

    const formatGoals = goals => goals.map(goal => ({
        player: {
            // name: goal.soccer.name,
            avatar: dustinWilliamsonAvatar,
            sniper: true,
            card: formatCard(goal.soccer),
        },
        time: goal.time
    }));

    const formatAssists = assists => assists.map(assist => ({
            player: {
                avatar: eduardoMilesAvatar,
                card: formatCard(assist.assistantFirst),
            }
        })
    );

    const formatter = matches => {
        if (!matches)
            return [];

        return matches.map(match => {
            const {team: homeTeam} = match.homeTeam;
            const {team: awayTeam} = match.awayTeam;
            const {goals, id} = match;
            const homeTeamGoals = goals.filter(goal => goal.team.name === homeTeam.name);
            const awayTeamGoals = goals.filter(goal => goal.team.name === awayTeam.name);

            const homeTeamAssists = goals.filter(goal => goal.team.name === homeTeam.name);
            const awayTeamAssists = goals.filter(goal => goal.team.name === awayTeam.name);

            return {
                matchId: id,
                team1: {
                    name: homeTeam.name,
                    logo: homeTeam.logo,
                    score: homeTeamGoals.length,
                    goals: formatGoals(homeTeamGoals),
                    assists: formatAssists(homeTeamAssists),
                },
                team2: {
                    name: awayTeam.name,
                    logo: awayTeam.logo,
                    score: awayTeamGoals.length,
                    goals: formatGoals(awayTeamGoals),
                    assists: formatAssists(awayTeamAssists),
                }
            }
        })
    };


    // Get filters values from props.
    const {regions, countries, competitions, teams, venues, search: _q} = props;
    const [q, setQ] = useState(_q);
    const [allLoaded, setAllLoaded] = useState(false);
    const [pagination, setPagination] = useState({
        currentPage: 1,
        pageSize: 10
    });


    const usePrevious = (value) => {
        const ref = useRef();
        useEffect(() => {
            ref.current = value;
        });
        return ref.current;
    };

    const prev = usePrevious(props);
    useEffect(() => {
        if (prev !== props) {
            setAllLoaded(false);
        }

    }, [props]);


    // Delay search process.
    Tools.delay(() => setQ(_q), 500);

    // Set request parameters.
    const variables = {
        q: Tools.convertEmptyToNull(q),
        regions: Tools.convertEmptyToNull(regions),
        countries: Tools.convertEmptyToNull(countries),
        competitions: Tools.convertEmptyToNull(competitions),
        teams: Tools.convertEmptyToNull(teams),
        stadiums: Tools.convertEmptyToNull(venues),
        skip: (pagination.currentPage - 1) * pagination.pageSize,
        take: pagination.pageSize,
    };

    const {loading, error, data} = useQuery(query, {
        variables: variables,
        notifyOnNetworkStatusChange: true
    });

    if (error) {
        return (
            <MatchesResults.Error error={error}/>
        );
    }

    const matches = formatter(data?.matches?.results);
    const filteredFrom = data?.matches?.filteredFrom;
    const total = data?.matches?.total;

    if (!loading && matches.length === 0) {
        return (
            <MatchesResults.NoResultFound/>
        );
    }

    return (
        <Fragment>
            <ShadowScrollbars loading={loading}>
                <Container fluid={true}>
                    <Row>
                        {matches.map((item, index) =>
                            <Col className="result-card-col" key={index} xs={12} md={6} lg={4}>
                                <ResultCard {...item}/>
                            </Col>)}
                    </Row>
                </Container>
            </ShadowScrollbars>
            <div style={{marginBottom: 50}}/>
            <Pagination
                pageSize={pagination.pageSize}
                currentPage={pagination.currentPage}
                pageSizeOptions={ShadowScrollbars.defaultOptions}
                defaultOption={ShadowScrollbars.defaultOption}
                totalSize={total}
                onChange={(pagination) => setPagination(pagination)}/>
        </Fragment>
    );
};

MatchesResults.Error = props =>
    <div className="w-100 h-100 d-flex justify-content-center align-items-center">
        <NoError text={"OOPS! Something went wrong"} details={"Error: " + props.error}/>
    </div>;

MatchesResults.NoResultFound = props =>
    <div className="w-100 h-100 d-flex justify-content-center align-items-center">
        <NoResultFound/>
    </div>;

export default MatchesResults;
